import React, { useState } from "react";
import { accountsApi } from "../api";
import { useI18n } from "../i18n";
import { showToast } from "../utils/toast";

export default function AccountCreateModal({ open, onClose }) {
  const { t } = useI18n();
  const [name, setName] = useState("");
  const [openingBalance, setOpeningBalance] = useState("");
  const [openingBalanceDate, setOpeningBalanceDate] = useState(() => new Date().toISOString().split('T')[0]);
  const [saving, setSaving] = useState(false);

  if (!open) return null;

  const handleSave = async () => {
    if (!name || saving) return;
    try {
      setSaving(true);
      await accountsApi.create({ name: name.trim(), openingBalance: parseFloat(openingBalance || 0), openingBalanceDate });
      if (onClose) onClose(true);
    } catch (e) {
      showToast({ message: String(e?.message || e), variant: 'error' });
    } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-green-900/10">
      <div className="w-full sm:w-[420px] bg-white rounded-t-2xl sm:rounded-2xl shadow-xl border border-green-100">
        <div className="p-4 border-b border-green-100 flex items-center justify-between">
          <div className="text-sm font-semibold text-gray-800">{t('acct.create.create')}</div>
          <button className="text-sm text-gray-500" onClick={()=>onClose && onClose(false)}>✕</button>
        </div>
        <div className="p-4 grid grid-cols-1 gap-2">
          <input className="border rounded px-3 py-2" placeholder={t('acct.create.name')} value={name} onChange={(e)=>setName(e.target.value)} />
          <input className="border rounded px-3 py-2" type="number" placeholder={t('acct.create.opening')} value={openingBalance} onChange={(e)=>setOpeningBalance(e.target.value)} />
          <input className="border rounded px-3 py-2" type="date" value={openingBalanceDate} onChange={(e)=>setOpeningBalanceDate(e.target.value)} />
        </div>
        <div className="p-4 flex gap-2">
          <button className={`flex-1 bg-green-600 text-white rounded-xl py-2 text-sm shadow ${saving?'opacity-60':''}`} disabled={saving} onClick={handleSave}>{saving ? t('acct.create.creating') : t('acct.create.create')}</button>
          <button className="flex-1 bg-white border border-green-200 text-green-700 rounded-xl py-2 text-sm" onClick={()=>onClose && onClose(false)}>{t('exp.modal.cancel')}</button>
        </div>
      </div>
    </div>
  );
}


